/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AttachmentMessageResponse } from '../api-models';
// @ts-ignore
import { DownloadSelectionRequest } from '../api-models';
// @ts-ignore
import { FileInfoModel } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { RenameRequest } from '../api-models';
/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
export const AttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a single attachment. The blob path must be the full path returned by  the list endpoint and must belong to the given facility and employee,  otherwise the request is rejected with 403. Requires the Folder Delete  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [fullBlobPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDelete: async (facilityId: string, employeeId: number, fullBlobPath?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDelete', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDelete', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fullBlobPath !== undefined) {
                localVarQueryParameter['fullBlobPath'] = fullBlobPath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Two phases on purpose. Once the first byte of the archive is on the wire the status code is  already sent, so every arm that answers with a status runs before the write begins.
         * @summary Downloads a folder and everything nested beneath it as a single zip. Requires the Folder  View permission for the target employee, the same permission that gates the listing and a  single file download, so this exposes nothing the caller could not already reach one file  at a time. Refused with 413 when the folder exceeds the configured file count or byte  limits, because those are the only bound on this path.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadFolderGet: async (facilityId: string, employeeId: number, folderPath?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadFolderGet', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadFolderGet', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}/download-folder`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderPath !== undefined) {
                localVarQueryParameter['folderPath'] = folderPath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads a single attachment as a file stream. The blob path must be the full  path returned by the list endpoint and must belong to the given facility and  employee, otherwise the request is rejected with 403. Requires the Folder View  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [fullBlobPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadGet: async (facilityId: string, employeeId: number, fullBlobPath?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadGet', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadGet', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}/download`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fullBlobPath !== undefined) {
                localVarQueryParameter['fullBlobPath'] = fullBlobPath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A POST because the selection travels in the body: a query string carrying many paths would  pass the 2048 bytes IIS allows a query string by default. Two phases, as in  M:OpenShifts.WebApi.Controllers.LocalStorage.AttachmentsController.DownloadFolder(System.String,System.Int64,System.String,System.Threading.CancellationToken): every answer with a status code is decided before the first  byte of the archive is written.
         * @summary Downloads the files and folders picked in an employee\'s Folder tab as a single zip. Every  entry keeps its path below the employee\'s root folder, so the archive extracts into the tree  the tab shows. A selected folder brings everything beneath it; the whole tab is downloaded by  selecting every item at the top level. Requires the Folder View permission for the target  employee, like the single file and the folder downloads. Refused with 413 when the selection  holds more files or bytes than the folder download\'s limits allow, or is a longer list than  any Folder tab sends.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {DownloadSelectionRequest} [downloadSelectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadSelectionPost: async (facilityId: string, employeeId: number, downloadSelectionRequest?: DownloadSelectionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadSelectionPost', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdDownloadSelectionPost', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}/download-selection`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists the attachment files stored for an employee, optionally scoped to a  subfolder beneath the employee\'s root folder. Requires the Folder View  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdGet: async (facilityId: string, employeeId: number, folderPath?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdGet', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderPath !== undefined) {
                localVarQueryParameter['folderPath'] = folderPath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads a file into the employee\'s attachment storage, optionally into a  subfolder beneath the employee\'s root folder. Requires the Folder Add  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdPost: async (facilityId: string, employeeId: number, folderPath?: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdPost', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdPost', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderPath !== undefined) {
                localVarQueryParameter['folderPath'] = folderPath;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renames a file or folder within the employee\'s attachment storage. The old  path must belong to the given facility and employee, otherwise the request is  rejected with 403. Returns 409 when the new name already exists. Requires the  Folder Edit permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {RenameRequest} [renameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdRenamePut: async (facilityId: string, employeeId: number, renameRequest?: RenameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdRenamePut', 'facilityId', facilityId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('attachmentsFacilityIdEmployeeIdRenamePut', 'employeeId', employeeId)
            const localVarPath = `/attachments/{facilityId}/{employeeId}/rename`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a single attachment. The blob path must be the full path returned by  the list endpoint and must belong to the given facility and employee,  otherwise the request is rejected with 403. Requires the Folder Delete  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [fullBlobPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdDelete(facilityId: string, employeeId: number, fullBlobPath?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdDelete(facilityId, employeeId, fullBlobPath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Two phases on purpose. Once the first byte of the archive is on the wire the status code is  already sent, so every arm that answers with a status runs before the write begins.
         * @summary Downloads a folder and everything nested beneath it as a single zip. Requires the Folder  View permission for the target employee, the same permission that gates the listing and a  single file download, so this exposes nothing the caller could not already reach one file  at a time. Refused with 413 when the folder exceeds the configured file count or byte  limits, because those are the only bound on this path.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdDownloadFolderGet(facilityId: string, employeeId: number, folderPath?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdDownloadFolderGet(facilityId, employeeId, folderPath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads a single attachment as a file stream. The blob path must be the full  path returned by the list endpoint and must belong to the given facility and  employee, otherwise the request is rejected with 403. Requires the Folder View  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [fullBlobPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdDownloadGet(facilityId: string, employeeId: number, fullBlobPath?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdDownloadGet(facilityId, employeeId, fullBlobPath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A POST because the selection travels in the body: a query string carrying many paths would  pass the 2048 bytes IIS allows a query string by default. Two phases, as in  M:OpenShifts.WebApi.Controllers.LocalStorage.AttachmentsController.DownloadFolder(System.String,System.Int64,System.String,System.Threading.CancellationToken): every answer with a status code is decided before the first  byte of the archive is written.
         * @summary Downloads the files and folders picked in an employee\'s Folder tab as a single zip. Every  entry keeps its path below the employee\'s root folder, so the archive extracts into the tree  the tab shows. A selected folder brings everything beneath it; the whole tab is downloaded by  selecting every item at the top level. Requires the Folder View permission for the target  employee, like the single file and the folder downloads. Refused with 413 when the selection  holds more files or bytes than the folder download\'s limits allow, or is a longer list than  any Folder tab sends.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {DownloadSelectionRequest} [downloadSelectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdDownloadSelectionPost(facilityId: string, employeeId: number, downloadSelectionRequest?: DownloadSelectionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdDownloadSelectionPost(facilityId, employeeId, downloadSelectionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lists the attachment files stored for an employee, optionally scoped to a  subfolder beneath the employee\'s root folder. Requires the Folder View  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdGet(facilityId: string, employeeId: number, folderPath?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileInfoModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdGet(facilityId, employeeId, folderPath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads a file into the employee\'s attachment storage, optionally into a  subfolder beneath the employee\'s root folder. Requires the Folder Add  permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {string} [folderPath] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdPost(facilityId: string, employeeId: number, folderPath?: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdPost(facilityId, employeeId, folderPath, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Renames a file or folder within the employee\'s attachment storage. The old  path must belong to the given facility and employee, otherwise the request is  rejected with 403. Returns 409 when the new name already exists. Requires the  Folder Edit permission for the target employee.
         * @param {string} facilityId 
         * @param {number} employeeId 
         * @param {RenameRequest} [renameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentsFacilityIdEmployeeIdRenamePut(facilityId: string, employeeId: number, renameRequest?: RenameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentsFacilityIdEmployeeIdRenamePut(facilityId, employeeId, renameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a single attachment. The blob path must be the full path returned by  the list endpoint and must belong to the given facility and employee,  otherwise the request is rejected with 403. Requires the Folder Delete  permission for the target employee.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDelete(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<AttachmentMessageResponse> {
            return localVarFp.attachmentsFacilityIdEmployeeIdDelete(requestParameters.facilityId, requestParameters.employeeId, requestParameters.fullBlobPath, options).then((request) => request(axios, basePath));
        },
        /**
         * Two phases on purpose. Once the first byte of the archive is on the wire the status code is  already sent, so every arm that answers with a status runs before the write begins.
         * @summary Downloads a folder and everything nested beneath it as a single zip. Requires the Folder  View permission for the target employee, the same permission that gates the listing and a  single file download, so this exposes nothing the caller could not already reach one file  at a time. Refused with 413 when the folder exceeds the configured file count or byte  limits, because those are the only bound on this path.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadFolderGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.attachmentsFacilityIdEmployeeIdDownloadFolderGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads a single attachment as a file stream. The blob path must be the full  path returned by the list endpoint and must belong to the given facility and  employee, otherwise the request is rejected with 403. Requires the Folder View  permission for the target employee.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.attachmentsFacilityIdEmployeeIdDownloadGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.fullBlobPath, options).then((request) => request(axios, basePath));
        },
        /**
         * A POST because the selection travels in the body: a query string carrying many paths would  pass the 2048 bytes IIS allows a query string by default. Two phases, as in  M:OpenShifts.WebApi.Controllers.LocalStorage.AttachmentsController.DownloadFolder(System.String,System.Int64,System.String,System.Threading.CancellationToken): every answer with a status code is decided before the first  byte of the archive is written.
         * @summary Downloads the files and folders picked in an employee\'s Folder tab as a single zip. Every  entry keeps its path below the employee\'s root folder, so the archive extracts into the tree  the tab shows. A selected folder brings everything beneath it; the whole tab is downloaded by  selecting every item at the top level. Requires the Folder View permission for the target  employee, like the single file and the folder downloads. Refused with 413 when the selection  holds more files or bytes than the folder download\'s limits allow, or is a longer list than  any Folder tab sends.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdDownloadSelectionPost(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.attachmentsFacilityIdEmployeeIdDownloadSelectionPost(requestParameters.facilityId, requestParameters.employeeId, requestParameters.downloadSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists the attachment files stored for an employee, optionally scoped to a  subfolder beneath the employee\'s root folder. Requires the Folder View  permission for the target employee.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<FileInfoModel>> {
            return localVarFp.attachmentsFacilityIdEmployeeIdGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads a file into the employee\'s attachment storage, optionally into a  subfolder beneath the employee\'s root folder. Requires the Folder Add  permission for the target employee.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdPost(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<AttachmentMessageResponse> {
            return localVarFp.attachmentsFacilityIdEmployeeIdPost(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renames a file or folder within the employee\'s attachment storage. The old  path must belong to the given facility and employee, otherwise the request is  rejected with 403. Returns 409 when the new name already exists. Requires the  Folder Edit permission for the target employee.
         * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsFacilityIdEmployeeIdRenamePut(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.attachmentsFacilityIdEmployeeIdRenamePut(requestParameters.facilityId, requestParameters.employeeId, requestParameters.renameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdDelete operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDelete
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDelete
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDelete
     */
    readonly fullBlobPath?: string
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdDownloadFolderGet operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGet
     */
    readonly folderPath?: string
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdDownloadGet operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGet
     */
    readonly fullBlobPath?: string
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdDownloadSelectionPost operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPost
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPost
     */
    readonly employeeId: number

    /**
     * 
     * @type {DownloadSelectionRequest}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPost
     */
    readonly downloadSelectionRequest?: DownloadSelectionRequest
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdGet operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdGet
     */
    readonly folderPath?: string
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdPost operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdPost
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdPost
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdPost
     */
    readonly folderPath?: string

    /**
     * 
     * @type {File}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdPost
     */
    readonly file?: File
}

/**
 * Request parameters for attachmentsFacilityIdEmployeeIdRenamePut operation in AttachmentsApi.
 * @export
 * @interface AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest
 */
export interface AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest {
    /**
     * 
     * @type {string}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePut
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePut
     */
    readonly employeeId: number

    /**
     * 
     * @type {RenameRequest}
     * @memberof AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePut
     */
    readonly renameRequest?: RenameRequest
}

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a single attachment. The blob path must be the full path returned by  the list endpoint and must belong to the given facility and employee,  otherwise the request is rejected with 403. Requires the Folder Delete  permission for the target employee.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdDelete(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDeleteRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdDelete(requestParameters.facilityId, requestParameters.employeeId, requestParameters.fullBlobPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Two phases on purpose. Once the first byte of the archive is on the wire the status code is  already sent, so every arm that answers with a status runs before the write begins.
     * @summary Downloads a folder and everything nested beneath it as a single zip. Requires the Folder  View permission for the target employee, the same permission that gates the listing and a  single file download, so this exposes nothing the caller could not already reach one file  at a time. Refused with 413 when the folder exceeds the configured file count or byte  limits, because those are the only bound on this path.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdDownloadFolderGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadFolderGetRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdDownloadFolderGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads a single attachment as a file stream. The blob path must be the full  path returned by the list endpoint and must belong to the given facility and  employee, otherwise the request is rejected with 403. Requires the Folder View  permission for the target employee.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdDownloadGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadGetRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdDownloadGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.fullBlobPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A POST because the selection travels in the body: a query string carrying many paths would  pass the 2048 bytes IIS allows a query string by default. Two phases, as in  M:OpenShifts.WebApi.Controllers.LocalStorage.AttachmentsController.DownloadFolder(System.String,System.Int64,System.String,System.Threading.CancellationToken): every answer with a status code is decided before the first  byte of the archive is written.
     * @summary Downloads the files and folders picked in an employee\'s Folder tab as a single zip. Every  entry keeps its path below the employee\'s root folder, so the archive extracts into the tree  the tab shows. A selected folder brings everything beneath it; the whole tab is downloaded by  selecting every item at the top level. Requires the Folder View permission for the target  employee, like the single file and the folder downloads. Refused with 413 when the selection  holds more files or bytes than the folder download\'s limits allow, or is a longer list than  any Folder tab sends.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdDownloadSelectionPost(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdDownloadSelectionPostRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdDownloadSelectionPost(requestParameters.facilityId, requestParameters.employeeId, requestParameters.downloadSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists the attachment files stored for an employee, optionally scoped to a  subfolder beneath the employee\'s root folder. Requires the Folder View  permission for the target employee.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdGet(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdGet(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads a file into the employee\'s attachment storage, optionally into a  subfolder beneath the employee\'s root folder. Requires the Folder Add  permission for the target employee.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdPost(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdPost(requestParameters.facilityId, requestParameters.employeeId, requestParameters.folderPath, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renames a file or folder within the employee\'s attachment storage. The old  path must belong to the given facility and employee, otherwise the request is  rejected with 403. Returns 409 when the new name already exists. Requires the  Folder Edit permission for the target employee.
     * @param {AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public attachmentsFacilityIdEmployeeIdRenamePut(requestParameters: AttachmentsApiAttachmentsFacilityIdEmployeeIdRenamePutRequest, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).attachmentsFacilityIdEmployeeIdRenamePut(requestParameters.facilityId, requestParameters.employeeId, requestParameters.renameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
